import { Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[zipCodeMask]'
})
export class ZipCodeDirective implements OnInit, OnDestroy{

  private _phoneControl:AbstractControl;
  private _preValue:string;
  private _numLen: number;

  @Input() 
  set phoneControl(control:AbstractControl){
    this._phoneControl = control;
  }
  @Input() 
  set preValue(value:string){
    this._preValue = value;
  }
  @Input()
  set numLen(value: number) {
    this._numLen = value;
  }
  private sub:Subscription;
  
  constructor(private el: ElementRef,private renderer:Renderer2) { }

  ngOnInit(){
    this.zipCodeValidate();
 }
 zipCodeValidate(): void {
    this.sub = this._phoneControl.valueChanges.subscribe(data => {
        let preInputValue:string = this._preValue;
        var lastChar:string = preInputValue.substr(preInputValue.length - 1);
        // remove all mask characters (keep only numeric)
        var newVal = data.replace(/\D/g, '');
        if(data.length >= this._numLen) {
          newVal = preInputValue.replace(/\D/g, '');
        }
        this._phoneControl.setValue(newVal,{emitEvent: false});
    });
 }
 ngOnDestroy() {
  this.sub.unsubscribe(); 
}

}
